/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Downloadlinksshowqr3Inputs */

const en_downloadlinksshowqr3 = /** @type {(inputs: Downloadlinksshowqr3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Show QR code`)
};

const de_downloadlinksshowqr3 = /** @type {(inputs: Downloadlinksshowqr3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`QR-Code zeigen`)
};

/**
* | output |
* | --- |
* | "Show QR code" |
*
* @param {Downloadlinksshowqr3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const downloadlinksshowqr3 = /** @type {((inputs?: Downloadlinksshowqr3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Downloadlinksshowqr3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_downloadlinksshowqr3(inputs)
	return de_downloadlinksshowqr3(inputs)
});
export { downloadlinksshowqr3 as "downloadLinksShowQr" }